module.exports = __webpack_public_path__ + "static/media/dc_two1.f6936286.jpg";